import { render, staticRenderFns } from "./dialog-info.vue?vue&type=template&id=3923b69c&"
import script from "./dialog-info.vue?vue&type=script&lang=ts&"
export * from "./dialog-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports